export * from './capitalize-sentence.filter';
